import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AgreementsArea from "../../components/shared-components/AgreementsArea";
import PastClientsComponent from "./myclients/PastClientsComponent";

const MyClientsComponent = ({ user }) => {
  const navigate = useNavigate();
  const { tab } = useParams();

  const tabNames = {
    current: "Current",
    previous: "Previous",
  };

  const tabComponents = {
    current: <AgreementsArea />,
    previous: <AgreementsArea />,
  };

  const [activeTab, setActiveTab] = useState(tab || "current");

  useEffect(() => {
    setActiveTab(tab || "current");
  }, [tab]);

  const handleTabClick = (key) => {
    navigate(`/account/ps-dashboard/agreements/${key}`);
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default MyClientsComponent;
